module.exports = __webpack_public_path__ + "static/media/Avatar_1.b1432ddf.svg";